<template>
  <div name="selection-detail">
    <div class="selection-system-header">
      <div class="selection-system-left">{{`${orgName}—${projectName}`}}</div>
      <div class="selection-system-right">
        <!-- <div class="system-left">{{projectName}}</div> -->
        <div class="system-right" @click="goBack">退出个人查询</div>
      </div>
    </div>
    <section class="selection-detail-content">
      <section class="list-area" v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <div class="list" v-if="!!list.length">
          <div class="item" v-for="item in list" :key="item.id" @click="goHousingEstateDetail(item)">
            <div class="img">
              <el-image style="width: 100%; height: 100%" :src="item.imgSrc" fit="cover" />
            </div>
            <div class="description">
              <div class="name">{{item.name}}</div>
              <div class="address">地址：{{item.address}}</div>
              <div class="area">建面：{{item.area}}</div>
              <div class="houses">可选房源数：{{item.houses}}</div>
            </div>
          </div>
        </div>
        <div style="height:80%" v-else>
          <None />
        </div>
      </section>
      <section class="page-box">
        <el-pagination style="float:right" background layout="prev, pager, next" @current-change="handleSizeChange" :page-size="page.pageSize" :current-page="page.pageNo" :total="page.total"></el-pagination>
      </section>
    </section>
  </div>
</template>

<script type='text/babel'>
import Nav from '@/components/nav.vue';
import None from '@/components/none.vue';
import { getSession, setSession, decodeURI, removeSession } from '@/untils';
import {
  getEstateInfoVoPage,
  logoutHouseholdIndex,
  queryHouseholdIndex
} from '@/api/publicinquiry.api.js';
import Cookies from 'js-cookie';
export default {
  name: 'selection-detail',
  data() {
    return {
      list: [],
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      householdId: '',
      orgName: '',
      projectName: '',
      tableLoading: false
    };
  },
  created() {
    this.orgName = getSession('newOrgName');
    this.projectName = getSession('projectName');
    console.log(getSession('userInfo'));
    this.householdId = getSession('userInfo') ? getSession('userInfo').householdId : '';
    this.queryHouseholdIndex();
  },
  methods: {
    // 查询公示项目分户档案信息
    queryHouseholdIndex() {
      const projectId = getSession('projectId');
      let params = { householdId: this.householdId };
      queryHouseholdIndex(projectId, params).then(res => {
        if (res) {
          setSession('userInfo', res.body);
          this.householdId = res.body.householdId;

          this.getList();
        }
      });
    },
    goBack() {
      this.$confirm('确定要退出个人查询么?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logoutHouseholdIndex(this.projectId).then(res => {
            if (res.code === 0) {
              removeSession('token');
              removeSession('session');
              removeSession('selectFlag');
              removeSession('tierBuildingHouseIds');
              removeSession('highBuildingHouseIds');
              removeSession('userInfo');
              removeSession('userInfo');
              Cookies.remove('token');
              Cookies.remove('yz_session_id');
              this.$router.push({ path: '/selection' });
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    handleSizeChange(val) {
      this.page.pageNo = val;
      this.getList();
    },
    getList() {
      this.tableLoading = true;
      const projectId = getSession('projectId');
      const { pageSize, pageNo } = this.page;
      this.list = []
      getEstateInfoVoPage(projectId, { pageSize, pageNo, tag: 1, householdId: this.householdId }).then(res => {
        if (res.code === 0) {
          const { records, total } = res.body;
          this.$set(this.page, 'total', total);
          this.list.splice(
            0,
            this.list.length,
            ...records.map(item => {
              const {
                unAllocationQuantity,
                address,
                housingEstateName,
                id,
                buildingAreaExtent,
                housingEstateAttachment,
                selectionHouseLimit
              } = item;
              const exist =
                housingEstateAttachment && housingEstateAttachment.id;
              const imgUrl =
                exist &&
                decodeURI(
                  `/housing/source/estatephoto/download/${housingEstateAttachment.id}/0`
                );
              return {
                imgSrc: imgUrl || require('@/assets/img/noPhoto.jpeg'),
                name: housingEstateName,
                address: address,
                area: (buildingAreaExtent && buildingAreaExtent + '㎡') || '',
                houses: unAllocationQuantity,
                selectionHouseLimit: selectionHouseLimit,
                id
              };
            })
          );
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.$message({
            message: res.errMsg,
            type: 'warning'
          });
        }
      });
    },
    goHousingEstateDetail(item) {
      // console.log(item);
      this.$router.push({
        path: 'housingEstateDetail',
        query: { housingEstateName: item.name, id: item.id, selectionHouseLimit: item.selectionHouseLimit }
      });
    }
  },
  components: {
    Nav,
    None
  }
};
</script>
<style scoped lang="less">
[name="selection-detail"] {
  background: #fff;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .selection-system-header {
    height: 40px;
    border-bottom: 1px solid rgb(2, 91, 145);
  }
  .selection-system-left {
    float: left;
    padding: 5px 0;
    text-indent: 15px;
    color: #025b91;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
  }
  .selection-system-right {
    float: right;
    display: flex;
  }
  .system-left {
    padding: 5px 150px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #1e1e1e;
  }
  .system-right {
    line-height: 30px;
    text-align: center;
    width: 100px;
    height: 30px;
    background: inherit;
    background-color: rgba(2, 91, 145, 1);
    border: none;
    border-top: 0px;
    border-radius: 10px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
  }
  .selection-detail-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10px;
    overflow: hidden;
    .list-area {
      flex: 1;
      overflow-y: auto;
      padding: 0 80px;
      .list {
        max-height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-bottom: 10px;
        .item {
          height: 120px;
          width: 48%;
          padding: 10px;
          border: 1px solid #999;
          box-sizing: border-box;
          margin-bottom: 10px;
          cursor: pointer;
          display: flex;
          .img {
            width: 130px;
            height: 100px;
          }
          .description {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-left: 40px;
            .name {
              text-decoration: underline;
              color: #409eff;
            }
            > div {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              max-width: 300px;
            }
          }
        }
      }
    }
  }
  .page-box {
    // padding: 0 80px;
    margin-top: 10px;
  }
  /deep/
    .page-box
    .el-pagination.is-background
    .el-pager
    li:not(.disabled).active {
    background-color: #025b91 !important;
    color: #fff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/project-system/selection/selection-detail.vue